let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9wHYa")).then(() => parcelRequire('1HGZy'));